import {createTheme} from "@mui/material";
import {Language} from "modules/enums";

import fieldEn from "assets/images/fieldEn-UNCOMPRESSED.png";
import fieldFr from "assets/images/fieldFr-UNCOMPRESSED.png";

declare module "@mui/material/styles" {
	// allow configuration using `createTheme`
	// eslint-disable-next-line @typescript-eslint/naming-convention
	interface ThemeOptions {
		[key: string]: unknown;
	}
}

export const themeObject = {
	baseFont: "Khand, sans-serif",
	secondFont: "Hind, sans-serif",
	baseTextColor: "#222222",

	colorPalette: {
		primary: "#FF00FF",
		secondary: "#00FFFF",
		black: "#202020",
		lightGrey: "#E5E5E5",
		white: "#FFFFFF",
	},

	playerPool: {
		heading: {
			background: "#525252",
			color: "#FFFFFF",
		},
		borderColor: "#E5E5EA",
	},

	buttons: {
		primary: {
			default: {
				background: "#FF00FF",
				color: "#202020",
				borderColor: "#FF00FF",
			},
			hover: {
				background: "#A408A4",
				color: "#202020",
				borderColor: "#A408A4",
			},
			disabled: {
				background: "#bcbcbc",
				color: "#ffffff",
				borderColor: "#bcbcbc",
				opacity: 0.3,
			},
		},
		secondary: {
			default: {
				background: "#00FFFF",
				color: "#202020",
				borderColor: "#00FFFF",
			},
			hover: {
				background: "#068080",
				color: "#202020",
				borderColor: "#068080",
			},
			disabled: {
				background: "#4babab",
				color: "#202020",
				borderColor: "#4babab",
				opacity: 0.3,
			},
		},
		primaryDark: {
			default: {
				background: "#FF00FF",
				color: "#202020",
				borderColor: "#FF00FF",
			},
			hover: {
				background: "#A408A4",
				color: "#202020",
				borderColor: "#A408A4",
			},
			disabled: {
				background: "#444446",
				color: "#878789",
				borderColor: "#444446",
				opacity: 0.3,
			},
		},
	},
	playerModal: {
		tabs: {
			color: "#636366",
			borderColor: "#C7C7CC",
			activeColor: "#C51A20",
		},
	},
	footer: {
		background: "#202020",
		color: "#FFFFFF",
		rightsColor: "#848484",
	},

	toastr: {
		background: "#202020",
		color: "#FFFFFF",
	},

	header: {
		LinkHover: "#1c1c1c",
		linkHoverBackground: "#FFFFFF",
		SubLinksItemTitle: "#b5262f",
		SubLink: "#1c1c1c",
		SubLinkHover: "#b5262f",
		mobileNavigation: "#1c1c1c",
		mobileIconHover: "#b5262f",
		mobileLinkActive: "#575757",
		color: "#ffffff",
		background: "#191919",
		headerSubLink: "#1c1c1c",
		headerSubLinkHover: "#b5262f",
		headerSubLinksItemTitle: "#b5262f",
	},
};

type ITheme = typeof themeObject;
export const theme = createTheme(themeObject);

export const breakpoints = {
	tablet: "1000px",
	medium: "769px",
	mobile: "640px",
};

export const fieldsImages = {
	[Language.English]: fieldEn,
	[Language.French]: fieldFr,
};

declare module "@mui/material/styles" {
	/**
	 *Disabled as it's allowing to avoid `any` type per MUI documentation
	 * https://mui.com/material-ui/customization/theming/#custom-variables
	 */

	// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-empty-interface
	interface Theme extends ITheme {}
}

declare module "@emotion/react" {
	/**
	 *Disabled as it's allowing to avoid `any` type per Emotion documentation
	 * https://emotion.sh/docs/typescript#define-a-theme
	 */

	// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-empty-interface
	interface Theme extends ITheme {}
}
